import { useState, useEffect, useRef, useMemo } from 'react';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';

import { getDateValue } from './DatePicker.helpers';

export const useDatePickerPresenter = ({
  value,
  minDate,
  maxDate,
  name,
  onBlur,
  disabled,
  autoFocus,
  offset,
}) => {
  const customInputRef = useRef(null);

  const [innerValue, setInnerValue] = useState(value);
  const [focused, setFocused] = useState(false);

  const presenter = {
    customInputRef,
    innerValue,
    focused,

    get popperModifiers() {
      return popperModifiers;
    },

    get dateValue() {
      return getDateValue(innerValue);
    },

    blurHandler(val) {
      setFocused(false);
      const format = 'DD.MM.YYYY';
      let newVal = val;
      let newDate = moment(newVal, format);
      if (!newDate.isValid()) {
        newDate = moment();
      }
      if (newDate.isBefore(moment(minDate))) {
        newVal = moment(minDate).format(format);
      }
      if (newDate.isAfter(moment(maxDate))) {
        newVal = moment(maxDate).format(format);
      }

      if (newVal !== val) {
        setInnerValue(newVal);
      }
      onBlur(name ? { [name]: newVal } : newVal);
    },

    inputChangeHandler(val) {
      if (val !== value) {
        setInnerValue(val);
      }
    },

    selectHandler(val) {
      const result = moment(val).format('DD.MM.YYYY');

      setInnerValue(result);
      onBlur(name ? { [name]: result } : result);
    },
  };

  const popperModifiers = useMemo(() => {
    return [
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['top'],
        },
      },
      {
        name: 'offset',
        options: { offset },
      },
    ];
  }, [offset]);

  useEffect(() => {
    setInnerValue(value);
    if (!disabled && autoFocus) {
      setFocused(true);
    }
  }, [value, disabled, autoFocus]);

  useEffect(() => {
    if (focused && customInputRef?.current) {
      customInputRef.current.element.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused, customInputRef?.current]);

  useEffect(() => {
    registerLocale('ru', ru);
  });

  return presenter;
};
